import AnnualPeriodsError from './AnnualPeriodsError';
class AnnualPeriodsYearsExceeds extends AnnualPeriodsError {
    numberOfYears;
    constructor(numberOfYears, options) {
        super('The number of years exceeds the crowdfunding property sale date', options);
        this.numberOfYears = numberOfYears;
    }
}
export default AnnualPeriodsYearsExceeds;
